"use strict";
exports.__esModule = true;
exports.DEFINITION_ROOT = "#/definitions/";
//# sourceMappingURL=constants.js.map